import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import type { SxProps, Theme } from "@mui/material";
import type { FC } from "react";
import SystemButton from "../SystemButton/SystemButton";

type Props = {
	/** Already translated: "Back", or where it goes ("Back to wage breakdown"). */
	label: string;
	onClick: () => void;
	/** DEFAULT: SystemButton's own `medium`. `small` where it shares a header row with tabs or a title. */
	size?: "small" | "medium";
	dataTestId: string;
	sx?: SxProps<Theme>;
};

/**
 * The app's "go back" control: a borderless button with a leading arrow, naming where it goes when that
 * is not just the previous page. Where it navigates is the caller's — a history step, a known origin, a
 * return that restores state — so one look serves every back affordance.
 */
export const SystemBackButton: FC<Props> = ({ label, onClick, size, dataTestId, sx }) => (
	<SystemButton data-testid={dataTestId} sx={sx} size={size} buttonVariant="borderless" leadingIcon={<ArrowBackIcon />} onClick={onClick}>
		{label}
	</SystemButton>
);
